module.exports = __webpack_public_path__ + "img/category_2.e1d064a2.svg";